<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal--store-header modal modal--welcomeback modal--zero-balance " id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
          <img class="usericon" src="static/images/happy_face_2.svg" alt="">
        </div>
        <div class="modal__body">
          <p class="modal_strong">
            {{ getBundleData.numberOfGames?getBundleData.numberOfGames + ' ' + getTranslations.home_modals_confirm_purchase_games:'' }}
              {{ getBundleData.numberOfGames && getBundleData.points ?getTranslations.home_modals_confirm_purchase_and:'' }}
             {{ getBundleData.points?getBundleData.points + ' ' + getTranslations.home_modals_confirm_purchase_points:''}}
           – {{ getBundleData.price
            }} {{ getBundleData.currencyCode }}</p>
          <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_playing_more }}</p>
          <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_purchase_now_by }} </p>
        </div>

      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters } from 'vuex';

export default {
  name: 'confirmPurchaseViaSms',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchaseViaSms.vue